<headerCustom></headerCustom>

<div class="modal fade" id="eligibilityCriteria" visisble="eligibilityCriteria" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document" style="max-width: 800px">
    <form>
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Eligibility Criteria</h5>
          <!-- <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button> -->
        </div>
        <div class="modal-body">
          <div class="all-details">
            <div class="pace-section">
              <div class="describe-section">
                <p class="note-excp">
                  Employees with exceptional contribution can be considered even
                  if one of the above criteria is not met. Such candidates will
                  be nominated separately, and self-nomination will not apply
                  for such cases.
                </p>
              </div>
            </div>
            <div class="nominee-detail-tb">
              <div id="accordion">
                <div class="card">
                  <div class="card-header">
                    <a class="card-link" data-toggle="collapse" href="#collapseOne">
                      CD
                    </a>
                  </div>
                  <div id="collapseOne" class="collapse show" data-parent="#accordion">
                    <div class="card-body">
                      <table cellspacing="0" border="1">
                        <tr>
                          <td style="min-width: 50px">Current Role</td>
                          <td style="min-width: 50px">Next Role</td>
                          <td style="min-width: 50px">
                            Tenure in current Role
                          </td>
                          <td style="min-width: 50px">BSC score</td>
                        </tr>
                        <tr>
                          <td style="min-width: 50px">
                            Associate content Lead
                          </td>
                          <td style="min-width: 50px">Content Lead</td>
                          <td style="min-width: 50px">1.5 YRS</td>
                          <td style="min-width: 50px">90%</td>
                        </tr>
                        <tr>
                          <td style="min-width: 50px">Content Lead</td>
                          <td style="min-width: 50px">Associate Analyst</td>
                          <td style="min-width: 50px">1.5 YRS</td>
                          <td style="min-width: 50px">85%</td>
                        </tr>
                        <tr>
                          <td style="min-width: 50px">Associate Analyst</td>
                          <td style="min-width: 50px">Analyst</td>
                          <td style="min-width: 50px">1.5 YRS</td>
                          <td style="min-width: 50px">85%</td>
                        </tr>
                        <tr>
                          <td style="min-width: 50px">Analyst</td>
                          <td style="min-width: 50px">Lead Analyst</td>
                          <td style="min-width: 50px">2 YRS</td>
                          <td style="min-width: 50px">85%</td>
                        </tr>
                        <tr>
                          <td style="min-width: 50px">Lead Analyst</td>
                          <td style="min-width: 50px">Principal Analyst</td>
                          <td style="min-width: 50px">3 YRS</td>
                          <td style="min-width: 50px">85%</td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>
                <div class="card">
                  <div class="card-header">
                    <a class="collapsed card-link" data-toggle="collapse" href="#collapseTwo">
                      CEP & RM
                    </a>
                  </div>
                  <div id="collapseTwo" class="collapse" data-parent="#accordion">
                    <div class="card-body">
                      <table cellspacing="0" border="1">
                        <tr>
                          <td style="min-width: 50px">Current Role</td>
                          <td style="min-width: 50px">Next Role</td>
                          <td style="min-width: 50px">
                            Tenure in current Role
                          </td>
                          <td style="min-width: 50px">BSC score</td>
                        </tr>
                        <tr>
                          <td style="min-width: 50px">
                            SENIOR SOFTWARE ENGINEER II
                          </td>
                          <td style="min-width: 50px">ASSOCIATE LEAD</td>
                          <td style="min-width: 50px">1.5 YRS</td>
                          <td style="min-width: 50px">90%</td>
                        </tr>
                        <tr>
                          <td style="min-width: 50px">
                            ASSOCIATE LEAD/ ASSOCIATE TECHNICAL CONSULTANT
                          </td>
                          <td style="min-width: 50px">
                            PROJECT LEAD /TECHNICAL CONSULTANT
                          </td>
                          <td style="min-width: 50px">1.5 YRS</td>
                          <td style="min-width: 50px">85%</td>
                        </tr>
                        <tr>
                          <td style="min-width: 50px">PROJECT LEAD</td>
                          <td style="min-width: 50px">
                            ASSOCIATE PROJECT MANAGER
                          </td>
                          <td style="min-width: 50px">1.5 YRS</td>
                          <td style="min-width: 50px">85%</td>
                        </tr>
                        <tr>
                          <td style="min-width: 50px">
                            TECHNICAL CONSULTANT /ASSOCIATE PROJECT MANAGER
                          </td>
                          <td style="min-width: 50px">
                            PROJECT MANAGER/TECHNICAL SPECIALIST
                          </td>
                          <td style="min-width: 50px">1.5 YRS</td>
                          <td style="min-width: 50px">85%</td>
                        </tr>
                        <tr>
                          <td style="min-width: 50px">
                            PM - TECHNICAL SPECIALIST
                          </td>
                          <td style="min-width: 50px">
                            SPM - -SR. TECHNICAL SPECIALIST
                          </td>
                          <td style="min-width: 50px">2 YRS</td>
                          <td style="min-width: 50px">85%</td>
                        </tr>
                        <tr>
                          <td style="min-width: 50px">
                            SR. TECHNICAL SPECIALIST
                          </td>
                          <td style="min-width: 50px">
                            LEAD TECHNICAL SPECIALIST (SPM to DM)
                          </td>
                          <td style="min-width: 50px">3 YRS</td>
                          <td style="min-width: 50px">85%</td>
                        </tr>
                        <tr>
                          <td style="min-width: 50px">
                            DM - LEAD TECHNICAL SPECIALIST
                          </td>
                          <td style="min-width: 50px">DH</td>
                          <td style="min-width: 50px">4 YRS</td>
                          <td style="min-width: 50px">85%</td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>
                <div class="card">
                  <div class="card-header">
                    <a class="collapsed card-link" data-toggle="collapse" href="#collapseThree">
                      UX
                    </a>
                  </div>
                  <div id="collapseThree" class="collapse" data-parent="#accordion">
                    <div class="card-body">
                      <table cellspacing="0" border="1">
                        <tr>
                          <td style="min-width: 50px">Current Role</td>
                          <td style="min-width: 50px">Next Role</td>
                          <td style="min-width: 50px">
                            Tenure in current Role
                          </td>
                          <td style="min-width: 50px">BSC score</td>
                        </tr>
                        <tr>
                          <td style="min-width: 50px">ASSOCIATE UX DESIGNER</td>
                          <td style="min-width: 50px">UX DESIGNER</td>
                          <td style="min-width: 50px">2 YRS</td>
                          <td style="min-width: 50px">85%</td>
                        </tr>
                        <tr>
                          <td style="min-width: 50px">UX DESIGNER</td>
                          <td style="min-width: 50px">UX DESIGN ARCHITECT</td>
                          <td style="min-width: 50px">3 YRS</td>
                          <td style="min-width: 50px">85%</td>
                        </tr>
                        <tr>
                          <td style="min-width: 50px">UX DESIGN ARCHITECT</td>
                          <td style="min-width: 50px">CREATIVE DIRECTOR</td>
                          <td style="min-width: 50px">4 YRS</td>
                          <td style="min-width: 50px">85%</td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>
                <div class="card">
                  <div class="card-header">
                    <a class="collapsed card-link" data-toggle="collapse" href="#collapseFour">
                      INSTRUCTIONAL DESIGN
                    </a>
                  </div>
                  <div id="collapseFour" class="collapse" data-parent="#accordion">
                    <div class="card-body">
                      <table cellspacing="0" border="1">
                        <tr>
                          <td style="min-width: 50px">Current Role</td>
                          <td style="min-width: 50px">Next Role</td>
                          <td style="min-width: 50px">
                            Tenure in current Role
                          </td>
                          <td style="min-width: 50px">BSC score</td>
                        </tr>
                        <tr>
                          <td style="min-width: 50px">
                            ASSOCIATE LEARNING DESIGNER
                          </td>
                          <td style="min-width: 50px">LEARNING DESIGNER</td>
                          <td style="min-width: 50px">1.5 YRS</td>
                          <td style="min-width: 50px">85%</td>
                        </tr>
                        <tr>
                          <td style="min-width: 50px">LEARNING DESIGNER</td>
                          <td style="min-width: 50px">
                            ASSOCIATE SENIOR LEARNING DESIGNER
                          </td>
                          <td style="min-width: 50px">2 YRS</td>
                          <td style="min-width: 50px">85%</td>
                        </tr>
                        <tr>
                          <td style="min-width: 50px">
                            ASSOCIATE SENIOR LEARNING DESIGNER
                          </td>
                          <td style="min-width: 50px">
                            ASSOCIATE PRINCIPAL LEARNING DESIGNER
                          </td>
                          <td style="min-width: 50px">3 YRS</td>
                          <td style="min-width: 50px">85%</td>
                        </tr>
                        <tr>
                          <td style="min-width: 50px">
                            ASSOCIATE PRINCIPAL LEARNING DESIGNER
                          </td>
                          <td style="min-width: 50px">
                            PRINCIPAL LEARNING DESIGNER
                          </td>
                          <td style="min-width: 50px">4 YRS</td>
                          <td style="min-width: 50px">85%</td>
                        </tr>
                        <tr>
                          <td style="min-width: 50px">
                            PRINCIPAL LEARNING DESIGNER
                          </td>
                          <td style="min-width: 50px">
                            LEAD PRINCIPAL LEARNING DESIGNER
                          </td>
                          <td style="min-width: 50px">6 YRS</td>
                          <td style="min-width: 50px">85%</td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>
                <div class="card">
                  <div class="card-header">
                    <a class="collapsed card-link" data-toggle="collapse" href="#collapseFive">
                      MEDIA
                    </a>
                  </div>
                  <div id="collapseFive" class="collapse" data-parent="#accordion">
                    <div class="card-body">
                      <table cellspacing="0" border="1">
                        <tr>
                          <td style="min-width: 50px">Current Role</td>
                          <td style="min-width: 50px">Next Role</td>
                          <td style="min-width: 50px">
                            Tenure in current Role
                          </td>
                          <td style="min-width: 50px">BSC score</td>
                        </tr>
                        <tr>
                          <td style="min-width: 50px">MEDIA VISUALIZER III</td>
                          <td style="min-width: 50px">
                            LEAD MEDIA VISUALIZER/ LEAD ANALYST
                          </td>
                          <td style="min-width: 50px">1.5 YRS</td>
                          <td style="min-width: 50px">90%</td>
                        </tr>
                        <tr>
                          <td style="min-width: 50px">
                            LEAD MEDIA VISUALIZER/ LEAD ANALYST
                          </td>
                          <td style="min-width: 50px">MEDIA MANAGER</td>
                          <td style="min-width: 50px">2 YRS</td>
                          <td style="min-width: 50px">85%</td>
                        </tr>
                        <tr>
                          <td style="min-width: 50px">MEDIA MANAGER</td>
                          <td style="min-width: 50px">SENIOR MEDIA MANAGER</td>
                          <td style="min-width: 50px">3 YRS</td>
                          <td style="min-width: 50px">85%</td>
                        </tr>
                        <tr>
                          <td style="min-width: 50px">SENIOR MEDIA MANAGER</td>
                          <td style="min-width: 50px">MEDIA TOWER HEAD</td>
                          <td style="min-width: 50px">4 YRS</td>
                          <td style="min-width: 50px">85%</td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>
                <div class="card">
                  <div class="card-header">
                    <a class="collapsed card-link" data-toggle="collapse" href="#collapseSix">
                      QC
                    </a>
                  </div>
                  <div id="collapseSix" class="collapse" data-parent="#accordion">
                    <div class="card-body">
                      <table cellspacing="0" border="1">
                        <tr>
                          <td style="min-width: 50px">Current Role</td>
                          <td style="min-width: 50px">Next Role</td>
                          <td style="min-width: 50px">
                            Tenure in current Role
                          </td>
                          <td style="min-width: 50px">BSC score</td>
                        </tr>
                        <tr>
                          <td style="min-width: 50px">
                            ASSISTANT TEAM MANAGER
                          </td>
                          <td style="min-width: 50px">PROJECT LEAD</td>
                          <td style="min-width: 50px">3 YRS</td>
                          <td style="min-width: 50px">90%</td>
                        </tr>
                        <tr>
                          <td style="min-width: 50px">PROJECT LEAD</td>
                          <td style="min-width: 50px">
                            SENIOR QUALITY MANAGER
                          </td>
                          <td style="min-width: 50px">4 YRS</td>
                          <td style="min-width: 50px">85%</td>
                        </tr>
                        <tr>
                          <td style="min-width: 50px">EDITOR</td>
                          <td style="min-width: 50px">SENIOR EDITOR</td>
                          <td style="min-width: 50px">2 YRS</td>
                          <td style="min-width: 50px">85%</td>
                        </tr>
                        <tr>
                          <td style="min-width: 50px">SENIOR EDITOR</td>
                          <td style="min-width: 50px">LEAD EDITOR</td>
                          <td style="min-width: 50px">3 YRS</td>
                          <td style="min-width: 50px">85%</td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn hvr-bounce-to-top" data-dismiss="modal" aria-label="Close"
            (click)="onClickOK()">
            OK
          </button>
        </div>
      </div>
    </form>
  </div>
</div>

<div class="main-content">
  <!-- Show users details in table -->
  <div class="adduserContainer">
    <div class="pageContentWrapper">
      <div class="pageHeading">
        <div class="row">
          <div class="col-9">
            <div class="headerName">
              <h3>Nominate yourself for new role</h3>
            </div>
          </div>
          <div class="col-md-3 text-right">
              <a class="btnRegister"
              href="assets/roles/{{nomineeData[0].TowerName.split(' ').join('') | lowercase}}Roles.pdf"
              target="_blank">
              View {{ nomineeData[0].TowerName }} Tower Roles
            </a>
          </div>

        </div>
      </div>
      <div class="addUserButtonTableData">
        <div class="container register">
          <div class="row">
            <!-- <div class="col-md-4 register-left">
              <img
                src="https://image.freepik.com/free-vector/job-candidate-hr-manager-meeting-interview_179970-1017.jpg"
                alt=""
              />
            </div> -->
            <div class="col-md-12 register-right">
              <div *ngIf="!nomination" class="tab-content">
                <div class="tab-pane fade show active" role="tabpanel" *ngIf="nomineeData.length">

                  <h3 class="register-heading d-none">
                    Nominate yourself for new role
                  </h3>
                  



                  <form class="register-form" [formGroup]="addUserForm" *ngFor="let nominee of nomineeData">
                    <div class="row topValues1">
                      <div class="col-md-3">
                        <div class="form-group topVAlues">
                          <label>Emp. Code:</label>
                          <span class="filledValue">{{ nominee.empCode }}</span>
                          <input type="text" class="form-control d-none" value="{{ nominee.empCode }}" disabled />
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group topVAlues">
                          <label>Employee Name:</label>
                          <span class="filledValue">{{ nominee.userName }}</span>
                          <input type="text" class="form-control d-none" value="{{ nominee.userName }}" disabled />
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group topVAlues">
                          <label>Tower:</label>
                          <span class="filledValue">{{ nominee.TowerName }}</span>
                          <input type="text" class="form-control d-none" value="{{ nominee.TowerName }}" disabled />
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group topVAlues">
                          <label>Current Role:</label>
                          <span class="filledValue">{{ nominee.CurrentPositionName }}</span>
                          <input type="text" class="form-control d-none" value="{{ nominee.CurrentPositionName }}"
                            disabled />
                        </div>
                      </div>
                    </div>

                    <div class="bottomValues">


                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group">
                            <label>New Role<span style="color: red">*</span></label>
                            <div>
                              <select class="form-control" (change)="onNextRoleSeclection($event)">
                                <option value="null">Select Position</option>
                                <ng-container *ngFor="let position of currentPositionList">
                                  <option value="{{ position.positionId }}" [selected]="
                                    position.positionId == nextPosition
                                  ">
                                    {{ position.positionName }}
                                  </option>
                                </ng-container>
                                <option value="other">Other IBU/Practice</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6 d-flex align-items-center">
                          <div class="form-group" style="margin-bottom: 0px">
                            <p style="
                              font-size: 12px;
                              font-style: italic;
                              margin-top: 12px;
                              margin-bottom: 0px;
                            ">
                              Select ‘<strong>Other IBU/Practice</strong>’ to choose a new role from a different IBU/Practice.
                            </p>
                            
                          </div>
                        </div>
                      </div>
                      <div class="nextRole" [class]="isOtherNextRole ? '' : 'd-none'">


                        <div class="row " [class]="isOtherNextRole ? '' : 'd-none'">
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="bwfdfiwefbi" class="col-form-label control-label">Other IBU</label>
                              <div>
                                <select id="form-ibu" class="form-control" (change)="onChangeIBU($event)">
                                  <option value="">Select IBU</option>
                                  <ng-container *ngFor="let ibuItem of ibuList">
                                    <option value="{{ ibuItem.ibuId }}">
                                      {{ ibuItem.ibuName }}
                                    </option>
                                  </ng-container>
                                </select>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="empCode" class="col-form-label control-label">Other Function</label>
                              <div>
                                <select id="form-function" class="form-control" (change)="onChangeFunction($event)">
                                  <option value="">Select Function</option>
                                  <ng-container *ngFor="let functionItem of functionList">
                                    <option value="{{ functionItem.functionId }}">
                                      {{ functionItem.functionName }}
                                    </option>
                                  </ng-container>
                                </select>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="empCode" class="col-form-label control-label">Other Tower</label>
                              <div>
                                <select id="form-tower" class="form-control" (change)="onChangeTower($event)">
                                  <option value="">Select Tower</option>
                                  <ng-container *ngFor="let towerItem of towerList">
                                    <option value="{{ towerItem.towerId }}">
                                      {{ towerItem.towerName }}
                                    </option>
                                  </ng-container>
                                </select>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label>Other New Role<span style="color: red">*</span></label>
                              <div>
                                <select class="form-control" id="form-other-next-role"
                                  (change)="onOtherNextRoleSeclection($event)">
                                  <option value="">Select Position</option>
                                  <ng-container *ngFor="let position of positionList">
                                    <option value="{{ position.positionId }}">
                                      {{ position.positionName }}
                                    </option>
                                  </ng-container>
                                </select>
                              </div>
                              <!-- <input
                            type="text"
                            class="form-control"
                            placeholder="Enter Next Role"
                            [(ngModel)]="otherNextPosition"
                            formControlName="otherNextPosition"
                          /> -->
                            </div>
                          </div>
                        </div>
                        <div class="row" [class]="isOtherNextRole ? '' : 'd-none'">
                          <div class="col-md-12">
                            <div class="form-group">
                              <p style="font-size: 12px">
                                Click
                                <a class="aLink" href="assets/clg_path_document.pdf" target="_blank">CLG - Growth Path Ladder</a>
                                to refer to other roles in CLG.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group">
                            <label>Exp. in Current Role (in Months.)
                              <span style="color: red">*</span></label>
                            <input type="number" class="form-control" [(ngModel)]="experience"
                              formControlName="experience" value="" [appDecimalNumber] />
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group">
                            <label>Latest BSC Score (H1/H2)
                              <span style="color: red">*</span></label>
                            <input type="number" [(ngModel)]="lastBSC" formControlName="lastBSC" class="form-control"
                              value="" [appDecimalNumber] />
                          </div>
                        </div>
                      </div>
                      <div class="row mt-3">
                        <div class="col-md-12">
                          <div class="form-group">
                            <label>Why do you want to move to the new role?
                              <span style="color: red">* </span>
                            </label>
                            <textarea rows="4" minlength="100" maxlength="{{ maxCharForWhyToMoveLength }}"
                              [(ngModel)]="whyMove" formControlName="whyMove" (input)="onTextChange()"
                              (onpaste)="onTextChange()" onKeyPress="if(this.value.length > 500) return false;"
                              class="form-control" placeholder="Please describe in minimum 100 characters."
                              required></textarea>
                            <label><span style="color: red">
                                {{ maxLeftCharacterWhyToMove }} characters left
                                out of Maximum :
                                {{ maxCharForWhyToMoveLength }}</span>
                            </label>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-12 text-right form-group">
                          <!-- <button type="button" class="btnRegister hvr-bounce-to-top mr-3">
                                                    Check Eligibility Criteria
                                                </button> -->
                          <!-- <span  *ngIf="showHideModel" class="termsAnd mr-3">
                                                    <input type="checkbox" name="elig-criteria" (change)="eligCriteria($event)"  data-toggle="modal" data-target="#eligibilityCriteria">
                                                    <label for="elig-criteria"> Eligibility Criteria</label>
                                                </span>
                                                <span *ngIf="!showHideModel" class="termsAnd mr-3">
                                                    <input type="checkbox" name="elig-criteria" checked (change)="eligCriteria($event)">
                                                    <label for="elig-criteria"> Eligibility Criteria</label>
                                                </span> -->
                          <!-- <input type="submit" class="btnRegister hvr-bounce-to-top" value="Nominate" /> -->
                          <button class="btnRegister hvr-bounce-to-top" (click)="onSubmit(addUserForm.value)">
                            Nominate
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                  <p class="note-desc">
                    Note: If your details are not correct, please contact your
                    HR
                  </p>
                </div>
              </div>

              <div *ngIf="nomination && errorNomination" class="not-eligible-wrapper">
                <!-- <div class="not-eligible">
                                    <h2 class="oops-heading">Thank you for submitting your request!</h2>
                                </div>
                                <div class="not-eligible-content">
                                    <p class="text-center">
                                        You have not match eligibility criteria for role change nomination this time. But still HR will analyse your data and get
                                        back to you, meanwhile please proceed your request.
                                    </p>
                                    <ul class="list-style d-none">
                                        <li>1. Exp. in current role is not >= 2 Years</li>
                                        <li>2. BSC Score is not >= 80%</li>
                                    </ul>
                                    <p class="tnt-heading d-none">But still HR will analyse your data and get back to you, meanwhile please proceed your
                                        request
                                    </p>
                                    <div class="text-center pt-15">
                                        <button type="button" class="btnProceed hvr-bounce-to-top mr-3" (click)="clickHereToProceed()">
                                            Click here to proceed
                                        </button>
                                    </div>
                                </div> -->
                <h2 class="succeed">Thanks!</h2>
                <p class="text-center">
                  Your nomination is submitted to HR. Please connect with your
                  HR for further process. You can check your nomination status
                  from home page as well.
                </p>
                <div class="text-center pt-15">
                  <button type="button" class="btnProceed hvr-bounce-to-top mr-3" (click)="clickHereToProceed()">
                    Back to Home Page
                  </button>
                </div>
              </div>
              <div *ngIf="nomination && !errorNomination" class="succeed-wrapper">
                <h2 class="succeed">Thanks!</h2>
                <p class="text-center">
                  Your nomination is submitted to HR. Please connect with your
                  HR for further process. You can check your nomination status
                  from home page as well.
                </p>
                <div class="text-center pt-15">
                  <button type="button" class="btnProceed hvr-bounce-to-top mr-3" (click)="clickHereToProceed()">
                    Back to Home Page
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="loader" *ngIf="loading">
  <div class="lds-roller">
    <!-- <img src="assets/preloader.gif" />
            <span>Wait...</span> -->
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
</div>

<!-- ----------------------------

<form [formGroup]="addUserForm" *ngIf="skillData && skillData.length >0">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">TR Nominee Detail Form</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-md-6">
            
            <div class="form-group">
              <label for="empCode" class="col-form-label control-label">Employee Code</label>
              <div>
                <input type="text" [ngClass]="{ 'is-invalid': submitted && f.empCode.errors }"
                placeholder="Enter Employee Code" class="form-control" [(ngModel)]="empCode"
                formControlName="empCode">
              </div>
            </div>
            </div>
            <div class="col-md-6">

            <div class="form-group">
                <label for="resourceName" class="col-form-label control-label">Employee Name</label>
                <div>
                  <input type="text" [ngClass]="{ 'is-invalid': submitted && f.resourceName.errors }"
                  placeholder="Enter Employee Name" class="form-control" [(ngModel)]="resourceName"
                  formControlName="resourceName">
                </div>
            </div>
          </div>
          
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
                <label for="resourceEmail" class="col-form-label control-label">Email id</label>
                <div>
                  <input type="text" [ngClass]="{ 'is-invalid': submitted && f.resourceEmail.errors }"
                    placeholder="Enter Email id" class="form-control" [(ngModel)]="resourceEmail"
                    formControlName="resourceEmail">
                </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
                <label for="resourceManager" class="col-form-label control-label">Supervisor Name</label>
                <div>
                  <input type="text" [ngClass]="{ 'is-invalid': submitted && f.resourceManager.errors }"
                    placeholder="Enter Supervisor Name" class="form-control" [(ngModel)]="resourceManager"
                    formControlName="resourceManager">
                </div>
            </div>
          </div>
        </div>
        <div class="row">
          
          <div class="col-md-6">
              <div class="form-group">
                  <label for="resourceManagerEmail" class="col-form-label control-label">Supervisor
                    Email</label>
                  <div>
                    <input type="text" [ngClass]="{ 'is-invalid': submitted && f.resourceManagerEmail.errors }"
                      placeholder="Enter Supervisor Email" class="form-control" [(ngModel)]="resourceManagerEmail"
                      formControlName="resourceManagerEmail">
                  </div>
                </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="SUPCode" class="col-form-label control-label">SUP code</label>
              <div>
                <input type="text" [ngClass]="{ 'is-invalid': submitted && f.SUPCode.errors }"
                  placeholder="Enter SUP Code" class="form-control" [(ngModel)]="SUPCode"
                  formControlName="SUPCode">
              </div>
            </div>
        </div>
        </div>
        <div class="row">
          
          <div class="col-md-6">
              <div class="form-group">
                <label for="SLS" class="col-form-label control-label">Second Level Supervisor Name</label>
                <div>
                  <input type="text" [ngClass]="{ 'is-invalid': submitted && f.SLS.errors }"
                    placeholder="Enter Second Level Supervisor" class="form-control" [(ngModel)]="SLS"
                    formControlName="SLS">
                </div>
              </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
                <label for="SLSE" class="col-form-label control-label">Second Level Supervisor Email</label>
                <div>
                  <input type="text" [ngClass]="{ 'is-invalid': submitted && f.SLSE.errors }"
                    placeholder="Enter Second Level Supervisor Email" class="form-control" [(ngModel)]="SLSE"
                    formControlName="SLSE">
                </div>
              </div>
        </div>
        </div>
        <div class="row">
          
          <div class="col-md-6">
              <div class="form-group">
                  <label for="SLST" class="col-form-label control-label">Total Trainings Attended</label>
                  <div>
                    <input type="number" [ngClass]="{ 'is-invalid': submitted && f.TTA.errors }"
                      placeholder="Enter Total Traininigs Attended" class="form-control" [(ngModel)]="TTA"
                      formControlName="TTA">
                  </div>
                </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
                <label for="currentPosition" class="col-form-label control-label">Current Role</label>
                <div>
                  <select class="form-control" [(ngModel)]="currentPosition" placeholder="Select Position" formControlName="currentPosition">
                    <option value="Select Position">Select Position</option>
                    <ng-container *ngFor="let position of positionList; let i = index;">
                      <option value="{{position.positionId}}">{{position.positionName}}</option>
                    </ng-container>
                  </select>
                </div>
              </div>
        </div>
        </div>

         <div class="row">
         
        </div>

        <div class="row">
          <div class="col-md-6">
              <div class="form-group">
                  <label for="joinDate" class="col-form-label control-label">Date Of Joining</label>
                  <div>
                    <div class="input-group">
                      <input autocomplete="off" [ngClass]="{ 'is-invalid': submitted && f.joinDate.errors }"
                        placeholder="yyyy-mm-dd" ngbDatepicker #d1="ngbDatepicker" [(ngModel)]="joinDate"
                        formControlName="joinDate" class="form-control">
                      <div class="input-group-append">
                        <button class="btn hvr-bounce-to-top" (click)="d1.toggle();" type="button">
                          <img src="assets/calendar-icon.svg" />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
          </div>
          <div class="col-md-6">
              <div class="form-group">
                  <label for="leaveDate" class="col-form-label">Date Of Leaving</label>
                  <div>
                    <div class="input-group">
                      <input class="form-control" type="text" [(ngModel)]="leaveDate" autocomplete="off"
                        placeholder="yyyy-mm-dd" ngbDatepicker #d2="ngbDatepicker" formControlName="leaveDate">
                      <div class="input-group-append">
                        <button class="btn hvr-bounce-to-top" (click)="d2.toggle();" type="button">
                          <img src="assets/calendar-icon.svg" />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
          </div>
        </div>

        
        
        
      </div>
      <div class="modal-footer">
        <button *ngIf="userUpdatedId >0" class="btn hvr-bounce-to-top" title="Update"
          (click)="onUpdateSubmit(addUserForm.value)" [disabled]="addUserForm.invalid">
          Update TR Nominee
        </button>
        <button *ngIf="userUpdatedId ==0" class="btn hvr-bounce-to-top"
          (click)="onSubmit(addUserForm.value)" [disabled]="addUserForm.invalid" >Add TR Nominee</button>
        <button type="button" class="btn hvr-bounce-to-top" data-dismiss="modal" aria-label="Close">Cancel</button>
      </div>
    </div>
  </form>

-->